import script from "./LoadingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingWidget.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__